import { render, staticRenderFns } from "./SupportCenter.vue?vue&type=template&id=3acb3d3e&scoped=true"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"
import style0 from "./SupportCenter.vue?vue&type=style&index=0&id=3acb3d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb3d3e",
  null
  
)

export default component.exports